export interface Book {
  slug: string;
  title: string;
  subtitle: string;
  author: string;
  category: string;
  format: string;
  description: string;
  suitableReaders: string;
  tags: string[];
  dataStatus: '待匯入' | '已確認';
  coverImage?: string;
  isbn?: string;
  publishDate?: string;
  series?: string;
}

export const books: Book[] = [
  {
    slug: 'northern-southern-dynasties-xiaoshi',
    title: '南北朝裂土誌：北魏變法與蕭氏內亂',
    subtitle: '太后臨朝、北魏南征、洛陽遷都、漢化改制、蕭氏內鬥',
    author: '譚自安',
    category: '中國歷史',
    format: '平裝',
    description: '南北朝裂土誌系列最新續章。北魏孝文帝改革開啟漢化進程，馮太后臨朝稱制推動均田制與俸祿改革，然南遷洛陽後的深層矛盾與蕭梁內部的權力傾軋，終將南北雙方推向更劇烈的裂變。',
    suitableReaders: '南北朝歷史愛好者',
    tags: ['南北朝', '北魏', '蕭梁', '中國歷史', 'S1025'],
    dataStatus: '已確認',
    coverImage: 'https://storage.helloreaddy.io/project_files/5b7aaa34-9bab-4986-a5b7-652c9dac38d9/ee3fb466-fe97-4d5f-974c-59511014e666_compressed_9786264283946.webp',
    isbn: '9786264283946',
    series: 'S1025',
  },
  {
    slug: 'ming-doctor-guild',
    title: '大明萬家醫館',
    subtitle: '她們以銀針破除偏見，在亂世中守住醫者仁心',
    author: '何木顏',
    category: '現代文學',
    format: '平裝',
    description: '穿越大明風雲，萬家醫館以懸壺濟世。在男尊女卑的時代，兩位女子憑藉精湛醫術與堅韌意志，於深院圍牆中守護生命，書寫屬於她們的傳奇篇章。',
    suitableReaders: '歷史小說與女性文學愛好者',
    tags: ['明朝', '歷史小說', '女性文學', '醫館', 'S1010'],
    dataStatus: '已確認',
    coverImage: 'https://storage.helloreaddy.io/project_files/5b7aaa34-9bab-4986-a5b7-652c9dac38d9/1a511721-2b1e-4258-a752-43d45c3247ae_compressed_9786264283939.webp',
    isbn: '9786264283939',
    series: 'S1010',
  },
  {
    slug: 'northern-warlord-reform-1922',
    title: '1922之後，武力改組的北洋政府',
    subtitle: '軍閥對峙、派系重組、國會紛爭、外交壓力',
    author: '趙焰',
    category: '近代史',
    format: '平裝',
    description: '從1922年第一次直奉戰爭到北洋政權的終局，聚焦武力改組下的軍閥政治、國會亂象與外交困局。在社會與政治雙重震盪中，中國如何一步步走向另一條進路？',
    suitableReaders: '近代史與民國史愛好者',
    tags: ['北洋政府', '軍閥', '近代史', '民國史', 'L3002'],
    dataStatus: '已確認',
    coverImage: 'https://storage.helloreaddy.io/project_files/5b7aaa34-9bab-4986-a5b7-652c9dac38d9/ce9c3952-2126-49d2-8b28-289d750548bc_compressed_9786264283779.webp',
    isbn: '9786264283779',
    series: 'L3002',
  },
  {
    slug: 'twenty-eight-historical-moments',
    title: '二十八個歷史瞬間，看懂朝代的轉折點',
    subtitle: '超震撼歷史名場面，一失足成千古恨',
    author: '黃帥',
    category: '中國歷史',
    format: '平裝',
    description: '二十八個改變朝代命運的關鍵瞬間——從武丁射天、王莽改制、淝水之戰到明清易代。那些被稱為關鍵的轉折，其實都是無數選擇逼近的結果，讓我們重新看見歷史深處的光與暗。',
    suitableReaders: '中國歷史與朝代轉折愛好者',
    tags: ['朝代轉折', '歷史名場面', '中國歷史', 'L4006'],
    dataStatus: '已確認',
    coverImage: 'https://storage.helloreaddy.io/project_files/5b7aaa34-9bab-4986-a5b7-652c9dac38d9/6f4799fb-cc77-4ebd-9520-195a8363638b_compressed_9786264283915.webp',
    isbn: '9786264283915',
    series: 'L4006',
  },
  {
    slug: 'sengoku-japan-shogunate',
    title: '戰國日本，割據的幕府時代',
    subtitle: '幕府失勢、大名混戰、京都內亂',
    author: '周華龍',
    category: '世界歷史',
    format: '平裝',
    description: '室町幕府衰微、地方豪族崛起、江戶幕府定鼎⋯⋯以大名興亡與家族內鬥為線索，重現日本由分裂走向統一的戰國分裂史。一部簡史看懂日本戰國分裂、霸權更替與德川幕府奠定的天下秩序。',
    suitableReaders: '日本歷史與戰國時代愛好者',
    tags: ['日本歷史', '戰國時代', '幕府', '世界歷史', 'L3007'],
    dataStatus: '已確認',
    coverImage: 'https://storage.helloreaddy.io/project_files/5b7aaa34-9bab-4986-a5b7-652c9dac38d9/bff29797-8902-4ff7-8844-522b248e19e4_compressed_9786264283922.webp',
    isbn: '9786264283922',
    series: 'L3007',
  },
  {
    slug: 'jiang-kui-untitled-life',
    title: '一生未仕，千古清詞姜夔',
    subtitle: '漂泊江湖，從淮南皓月到江南梅影',
    author: '吳文浩、蘇珊',
    category: '古典文學',
    format: '平裝',
    description: '一段無法重逢的情事、終身未仕卻獨立文壇。如何將相思化為梅影、柳色與皓月，成就白石詞最幽深的意象世界？在漂泊寄居、知音交遊與深情追憶中開創南宋詞的新境界！',
    suitableReaders: '古典文學愛好者、詞學研究者',
    tags: ['南宋詞', '白石詞', '姜夔', '古典文學', 'S1017'],
    dataStatus: '已確認',
    coverImage: 'https://storage.helloreaddy.io/project_files/5b7aaa34-9bab-4986-a5b7-652c9dac38d9/21f68b88-34dc-4843-b96b-c49f8b86187d_compressed_9786264284059.webp',
    isbn: '9786264284059',
    series: 'S1017',
  },
  {
    slug: 'xu-wei-mad-genius',
    title: '文人抗倭，狂筆奇才徐渭',
    subtitle: '八試不第、癲狂人獄、貧病狂疾⋯⋯',
    author: '劉超',
    category: '歷史人物',
    format: '平裝',
    description: '半生癲狂，一代孤絕畸才——徐渭！以詩文書畫寫盡明代畸人的孤憤與不朽。一生困於科舉、家變、政局與心魔，卻在書法、戲曲與寫意花鳥中開出晚明最驚世的才情。',
    suitableReaders: '明代文學與藝術愛好者',
    tags: ['明代', '徐渭', '書畫', '戲曲', '歷史人物', 'S1018'],
    dataStatus: '已確認',
    coverImage: 'https://storage.helloreaddy.io/project_files/5b7aaa34-9bab-4986-a5b7-652c9dac38d9/632b9e6c-4f8b-4563-affc-70b26c6e0894_compressed_9786264284073.webp',
    isbn: '9786264284073',
    series: 'S1018',
  },
  {
    slug: 'ji-kang-bamboo-grove',
    title: '竹林名士嵇康',
    subtitle: '東市一曲廣陵散，竹林名士嵇康',
    author: '劉芸',
    category: '歷史人物',
    format: '平裝',
    description: '清峻不群，不仕亂世的竹林名士。聲無哀樂、養生之辯、竹林之遊、廣陵絕響⋯⋯在名教與權力之間，照見一代高士的孤絕身影。從魏晉名士到司馬氏眼中的異端，從正始名士看一代奇才的自由與悲劇。',
    suitableReaders: '魏晉風度與竹林七賢研究者',
    tags: ['魏晉', '嵇康', '竹林七賢', '歷史人物', 'S1019'],
    dataStatus: '已確認',
    coverImage: 'https://storage.helloreaddy.io/project_files/5b7aaa34-9bab-4986-a5b7-652c9dac38d9/8eac28a2-97b8-4342-9916-55b20998b03e_compressed_9786264284158_3D_72dpi.webp',
    isbn: '9786264284158',
    series: 'S1019',
  },
  {
    slug: 'ancient-obsessions-classics',
    title: '古人的執念，藏在名篇裡',
    subtitle: '讀懂三十位文豪的人生與成敗',
    author: '趙慕宇',
    category: '古典文學',
    format: '平裝',
    description: '從《醉翁亭記》、《岳陽樓記》到《湖心亭看雪》，讀懂三十位文豪的人生與成敗。沿著古人的命運轉折，讀出文學奇觀的孤獨、堅持與未竟之志。一首詩、一篇文、一段掌故，藏著一個人最深的執念。',
    suitableReaders: '古典散文與名篇愛好者',
    tags: ['古典散文', '名篇', '文學賞析', 'S1020'],
    dataStatus: '已確認',
    coverImage: 'https://storage.helloreaddy.io/project_files/5b7aaa34-9bab-4986-a5b7-652c9dac38d9/e7964261-d26e-4962-b48b-059ec8c57bcd_compressed_9786264284141_3D_72dpi.webp',
    isbn: '9786264284141',
    series: 'S1020',
  },
  {
    slug: 'northern-southern-dynasties',
    title: '南北朝裂土誌：北齊開國與江南兵劫',
    subtitle: '東魏傀儡、關中割據、梁武困城、宗王坐觀',
    author: '譚自安',
    category: '中國歷史',
    format: '平裝',
    description: '權臣代興與藩鎮叛亂交相引爆，南北朝進入更殘酷的裂變時代！賀拔遇害、宇文接軍、孝武入關、高歡失玉璧、侯景破臺城⋯⋯北方雙雄對峙未決，江南帝國為何先一步走向崩壞？',
    suitableReaders: '南北朝歷史愛好者',
    tags: ['南北朝', '北齊', '侯景之亂', '中國歷史', 'S1022'],
    dataStatus: '已確認',
    coverImage: 'https://storage.helloreaddy.io/project_files/5b7aaa34-9bab-4986-a5b7-652c9dac38d9/a8947c4b-9622-4c13-9f66-502ebb080cc0_compressed_9786264284080.webp',
    isbn: '9786264284080',
    series: 'S1022',
  },
  {
    slug: 'records-of-the-grand-historian',
    title: '筆下留名：史記列傳英雄誌',
    subtitle: '忠臣名將×謀士辯才×隱逸智者×遊方醫家',
    author: '張新科、趙望秦、程永莊',
    category: '中國歷史',
    format: '平裝',
    description: '透過三十位經典人物的命運起伏，進入司馬遷筆下的歷史現場與人性世界。風雲人物皆入史，史記列傳群像！治國賢相、兵家名將、縱橫策士、失意英雄，讀見《史記》如何以細節、對話與命運轉折刻畫不朽人物。',
    suitableReaders: '史記與中國歷史愛好者',
    tags: ['史記', '司馬遷', '歷史人物', '中國歷史', 'S1023'],
    dataStatus: '已確認',
    coverImage: 'https://storage.helloreaddy.io/project_files/5b7aaa34-9bab-4986-a5b7-652c9dac38d9/a955f3c1-3920-4af6-8411-4ab2970115a3_compressed_9786264284066.webp',
    isbn: '9786264284066',
    series: 'S1023',
  },
  {
    slug: 'xiao-liang-dingding',
    title: '南北朝裂土誌：蕭梁定鼎與爾朱亂世',
    subtitle: '禪位篡國×宗室屠戮×北伐失利×邊鎮叛亂',
    author: '譚自安',
    category: '中國歷史',
    format: '平裝',
    description: '蕭衍代齊、鍾離鏖兵、胡太后亂政、六鎮烽火、爾朱榮入洛⋯⋯南梁霸朝如何站穩江南，北魏帝國又如何一步步走向分裂？南方新局初定之時，北方霸權為何轟然崩塌？',
    suitableReaders: '南北朝歷史愛好者',
    tags: ['南北朝', '梁武帝', '爾朱榮', '六鎮', 'S1021'],
    dataStatus: '已確認',
    coverImage: 'https://storage.helloreaddy.io/project_files/5b7aaa34-9bab-4986-a5b7-652c9dac38d9/ff210539-db57-4109-8021-638b48318632_compressed_9786264284004.webp',
    isbn: '9786264284004',
    series: 'S1021',
  },
  {
    slug: 'ladybug-sticker',
    title: '瓢蟲貼紙',
    subtitle: '情人節之夜，月光酒店5202間',
    author: '于凡',
    category: '現代文學',
    format: '平裝',
    description: '路過熙攘，慶幸終點有你，繼續前行，依然相信愛情。情人節之夜，月光酒店5202間。床頭櫃那盞散發出紫色燈光的檯燈上，赫然趴著一隻瓢蟲。那是一張貼紙，瓢蟲似乎在光滑的玻璃燈罩上爬來爬去⋯⋯我是誰？現在我是誰？',
    suitableReaders: '現代小說與愛情文學愛好者',
    tags: ['現代小說', '愛情', '懸疑', 'S1016'],
    dataStatus: '已確認',
    coverImage: 'https://storage.helloreaddy.io/project_files/5b7aaa34-9bab-4986-a5b7-652c9dac38d9/51a2a368-314d-4560-8557-b6ef70bb05d2_compressed_9786264284011.webp',
    isbn: '9786264284011',
    series: 'S1016',
  },
  {
    slug: 'classical-literature-lived',
    title: '古典文學裡，有人這樣活過',
    subtitle: '從詩歌、文章、戲曲到小說，讀懂古典文學的流變',
    author: '駱玉明',
    category: '古典文學',
    format: '平裝',
    description: '古人寫下的，不只是風花雪月，還有理想受挫、生命無常與人間深情。從詩歌、文章、戲曲到小說，讀懂古典文學的流變、形式與精神世界。走進古人真實而遼闊的精神世界。',
    suitableReaders: '古典文學愛好者與入門讀者',
    tags: ['古典文學', '文學史', '駱玉明', 'S1014'],
    dataStatus: '已確認',
    coverImage: 'https://storage.helloreaddy.io/project_files/5b7aaa34-9bab-4986-a5b7-652c9dac38d9/969139a9-8852-4401-8d7f-b0134f430462_compressed_9786264283953.webp',
    isbn: '9786264283953',
    series: 'S1014',
  },
  {
    slug: 'heroes-multiverse',
    title: '英雄的多重宇宙：探索三國人物的生成與流變',
    subtitle: '為何我們愛劉備、恨曹操？',
    author: '陳文新',
    category: '中國歷史',
    format: '平裝',
    description: '看經典如何承載道德判斷、人物愛憎與時代想像。讀三國，不只看英雄成敗，小說有小說的安排，掌故有掌故的情味。一本書，一次讀懂多層次的三國世界。',
    suitableReaders: '三國歷史與文學愛好者',
    tags: ['三國', '陳文新', '人物評論', '中國歷史', 'S1015'],
    dataStatus: '已確認',
    coverImage: 'https://storage.helloreaddy.io/project_files/5b7aaa34-9bab-4986-a5b7-652c9dac38d9/69f9ab9f-975b-4fb2-8db1-3b447f5193b1_compressed_9786264283991.webp',
    isbn: '9786264283991',
    series: 'S1015',
  },
];
